import assign from 'lodash/assign';

import { VideoSliderServiceModule } from 'components/videoSlider/videoSlider.service';

import './emptyListPage.scss';

export const EmptyListPageComponentModule = angular
    .module('app.components.emptyListPage', [VideoSliderServiceModule])
    .component('emptyListPage', {
        template: `
            <div class="empty-list-page" layout="column" layout-align="center center">
                <div class="empty-list-page__image">
                    <md-icon ng-if="$ctrl.icon">{{$ctrl.icon}}</md-icon>
                    <md-icon ng-if="$ctrl.iconSvgSrc" md-svg-src="{{$ctrl.iconSvgSrc}}"></md-icon>
                </div>
                <h1 class="empty-list-page__headline">{{$ctrl.headline | translate}}</h1>
                <p class="empty-list-page__message" ng-if="$ctrl.message">{{$ctrl.message | translate}}</p>
                <div ng-if="$ctrl.showVideoMenu" class="empty-list-page__videoslider-link"
                    ng-click="$ctrl.openVideoSlider()">
                    <md-icon>play_circle_outline</md-icon> {{'LABEL.WATCH_VIDEO' | translate}}
                </div>
                <md-button
                    ng-if="$ctrl.showAddButton"
                    class="md-button--has-icon-left md-raised md-accent"
                    ui-sref="{{$ctrl.addButtonLink}}"
                    ng-click="$ctrl.addButtonOnClick()"
                    gtm-click-event="{{$ctrl.gtmId}}-add-link">
                    <md-icon>add</md-icon>
                    <span>{{$ctrl.addButtonText | translate}}</span>
                </md-button>
                <div ng-transclude></div>
            </div>
        `,
        transclude: true,
        bindings: {
            icon: '@',
            iconSvgSrc: '@',
            headline: '@',
            message: '@',
            showAddButton: '<',
            addButtonLink: '@',
            addButtonOnClick: '&',
            addButtonText: '@',
            gtmId: '<',
            videoLink: '<'
        },
        controller: class EmptyListPageController {
            constructor(videoSliderService) {
                'ngInject';

                assign(this, {
                    videoSliderService
                });
            }

            $onInit() {
                this.showVideoMenu = !!this.videoLink;
            }

            openVideoSlider() {
                this.videoSliderService.openSlider(this.videoLink);
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/emptyListPage/emptyListPage.js